// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3d6e4ab1","455":"0ecfed12"}[chunkId] + ".chunk.js";
};